import React, {useState, useEffect} from 'react';
import {t} from 'ttag';
import QRCode from 'qrcode';
import * as Title from '../../../../title/title.jsx';
import Article from '../../../../article/article.jsx';
import Text from '../../../../text/text.jsx';
import Wrapper from '../../../../wrapper/wrapper.jsx';
import QR from '../../../../qr/qr.jsx';
import Link from '../../../../link/link.jsx';
import {useAppContext} from '../../../../../app-context.js';
import Preloader from 'components/preloader/preloader.jsx';
import EmptyBox from 'components/empty-box/empty-box.jsx';
import Advice from 'components/advice/advice';
import Confirmation from 'components/confirmation/confirmation.jsx';
import {useRequest} from 'common/hooks/index.js';
import {updateEmployeeReq} from 'common/api/api.js';
import upd from 'immutability-helper';

const Notifications = () => {
  const {employeeList, user, setEmployeeList} = useAppContext();

  const [manager, setManager] = useState();
  const [qr, setQr] = useState();
  const [isConfirmActive, setIsConfirmActive] = useState(false);

  const {request} = useRequest();

  const getManager = () => {
    let newManager = employeeList?.find(
      manager => manager.crm_user_id == user.user_id
    );

    if (newManager) return setManager(newManager);

    newManager = employeeList?.find(manager => manager.email == user.domain);
    setManager(newManager || null);
  };

  useEffect(() => {
    if (!manager) return;

    QRCode.toDataURL(`https://t.me/whatcrm_bot?start=${manager.ukey}`).then(
      res => setQr(res || null)
    );
  }, [manager]);

  useEffect(() => {
    getManager();
  }, []);

  const updateTelegramId = async () => {
    const res = await request(
      updateEmployeeReq(user.id, manager.id, {telegram_id: 0})
    );

    if (!Object.keys(res).length) return true;

    setEmployeeList(prevValue => {
      const index = prevValue?.findIndex(item => item.id == manager.id);
      if (index == undefined || index < 0) return prevValue;

      return upd(prevValue, {[index]: {telegram_id: {$set: 0}}});
    });

    setIsConfirmActive(false);
    setManager(prevValue => upd(prevValue, {telegram_id: {$set: 0}}));
  };

  const handleClick = res => {
    if (!res) return setIsConfirmActive(false);
    return updateTelegramId();
  };

  return (
    <>
      <Title.H3 style={{marginBottom: 8}}>
        {t`Notifications in Telegram`}
      </Title.H3>

      <Article style={{marginBottom: 16}}>
        <Text>{t`Set up the bot to receive important notifications about your connections.`}</Text>
      </Article>

      {typeof manager == 'object' ? (
        manager ? (
          typeof qr != 'undefined' ? (
            qr ? (
              <Wrapper alignItems="center" gap={0} isColumn>
                {manager.telegram_id > 0 && (
                  <Advice
                    type="success"
                    style={{width: '100%', marginBottom: 16}}
                  >
                    <Wrapper alignItems="center" justifyContent="space-between">
                      <Title.H3>{t`Telegram bot is connected`}</Title.H3>

                      <Link
                        color="dark"
                        isFake
                        onClick={() => setIsConfirmActive(true)}
                        style={{textDecoration: 'underline'}}
                      >{t`Disconnect`}</Link>
                    </Wrapper>
                  </Advice>
                )}

                <QR qr={qr} style={{marginBottom: 16}} />

                <Link
                  href={`https://t.me/whatcrm_bot?start=${manager.ukey}`}
                  target="_blank"
                >
                  {'t.me/whatcrm_bot'}
                </Link>
              </Wrapper>
            ) : (
              <EmptyBox title={t`Error`}>
                <Text>{t`Couldn’t find your unique key.`}</Text>
              </EmptyBox>
            )
          ) : (
            <Preloader />
          )
        ) : (
          <EmptyBox title={t`Error`}>
            <Text>{t`Couldn't identify you.`}</Text>
          </EmptyBox>
        )
      ) : (
        <Preloader />
      )}

      {isConfirmActive && (
        <Confirmation
          title={t`Disconnect Telegram bot?`}
          onClick={handleClick}
        />
      )}
    </>
  );
};

export default Notifications;
